export default {
  Yield: "Yield in advance by direct debit",
  IpsNetRate: "IP Syndicate net rate",
  Per1000DifferenceMinForIps: `${process.env.MAJOR_CURRENCY} per ${process.env.MAJOR_CURRENCY}1,000 difference min for IP Syndicate`,
  DealerNetRate: "Supplier net rate",
  GrossSalesRate: "Gross sales rate",
  IpsYieldAtDealerNetRate: "IP Syndicate yield at Dealer net rate"
};
